import React from 'react'

import InputContainer from './InputContainer'
const defaultInputClass = 'ncss-input pt2-sm pr4-sm pb2-sm pl4-sm'

export default ({ label, input, title, meta, ...props }) => (
  <InputContainer label={label} meta={meta} title={title}>
    <input type='number' className={props.className || defaultInputClass} {...props} onChange={wrap(input.onChange)} onBlur={wrap(input.onBlur)} />
  </InputContainer>
)

const wrap = (fn) => {
  if (!fn) return undefined
  return (e) => fn(e.target.value ? parseFloat(e.target.value) : null)
}



// WEBPACK FOOTER //
// ./client/src/components/forms/NumericInput.js